export class UpdateUserLanguageResponse {
  public Successful: boolean = false;
  public Message: string = "";
}

